<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">社團資料建立</span>
        <div class="row">
            <div class="col-12">
                <form-select v-model="vm.Property" id="Property" label="屬性" required>
                    <slot name="propertys"></slot>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Name" id="Name" label="名稱" type="text" required></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.EngName" id="EngName" label="英文名稱" type="text"></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Group" id="Group" label="組別(請用,隔開)" type="text"></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'communityDetail',
        api: '/api/community/'
    });
</script>

<style>
</style>